import React from 'react';

import OOTableContainer from '@components/admin/Table/OOTableContainer';
import { PageWrapper } from '@components/app/PageWrapper/PageWrapper';

import EmailOverviewTable from './components/EmailOverviewTable';

const EmailOverview = () => {
  return (
    <div className="email-overview">
      <PageWrapper
        featureName="email-overview"
        pageName="email-overview"
        sideMenu
        headerConfig={{
          pageName: 'Email overview',
          languagePicker: true,
        }}
      >
        <OOTableContainer>
          <EmailOverviewTable />
        </OOTableContainer>
      </PageWrapper>
    </div>
  );
};

export default EmailOverview;
